import * as BoxType from '@/services/rest-api/lib/delivery/box-type'

const field = {
  name: 'box_type_id',
  showKey: 'box_type.id',
  type: 'select-resourceful-v2',
  label: 'Jenis Box',
  optionsGetter: BoxType.get,
  optionLabelFn: ({ item }) => item.name,
  placeholder: 'Pilih Jenis Box',
}

export default field